import { createContext, useContext } from 'react';

export const MapContext = createContext({
  isSettled: false,
});

export const useMapContext = () => {
  const ctx = useContext(MapContext);
  if (!ctx) {
    throw new Error('MapContext cannot be used outside of a MapContext.Provider');
  }
  return ctx;
};
